export const exportGrid = `
    query exportGrid($input: ExportGridInput!) {
        exportGrid(input: $input) {
            signedUrl
            receiptId
        }
    }
`;
